import React from "react";

const AuthButton = ({ provider, icon, label, onSignIn, disabled = false }) => (
  <button
    type="button"
    onClick={() => onSignIn(provider)}
    disabled={disabled}
    className="relative flex items-center justify-center px-4 py-2 border shadow-sm text-sm font-medium rounded-md min-h-[42px] hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <img className="w-5 h-5 absolute left-4" src={icon} alt="logo" />
    <span className="text-slate-700">{label}</span>
  </button>
);

export default AuthButton;
